/**
 *
 * Download Form
 *
 * UI for interacting with the download form
 */

const $ = require('jQuery');
const _LStorage = require('./utilities/_LStorage');

var DownloadUI = function(el){

    this.$el                = $( el );
    this.$form              = this.$el.find( '.itbl-b-form' );

    //get all visible form input fields as array
    this.$visibleInputs     = this.$form.find( 'select,input:visible:not(input[type=submit])' ).map( (i, el ) => el.getAttribute( 'name') ).get();

    //known user elements
    this.$userName          = this.$el.find( '.itbl-c-form__username' );
    this.$returningUserCTA  = this.$el.find( '.itbl-c-form__known-user-cta' );
    this.$userEmailEl       = this.$el.find( '.itbl-c-form__user-email' );
    this.$wrongUser         = this.$el.find( '.itbl-c-form__known-user-we-got-it-wrong' );


    //success message SVG classes
    this.$confirmation      = this.$el.find( '.itbl-c-form__confirmation' );
    this.$confirmationWrap  = this.$el.find( '.itbl-b-form__confirmation-overflow' );

    this.$downloadImg       = this.$el.find( '.itbl-c-form__download-img' );

    //these fields and event directly relate to the contact
    this.isContact          = this.$form.hasClass( 'itbl-c-form-contact' );
    this.$returningContactCTA  = this.$el.find( '.itbl-c-form__known-user-contact' );

    this.itblObj    = 'iterable';
    this.actions    = ['events'];
    this.deckable   = null;
    this.parsedData = null;

    //get the user email from localstorage
    this.userEmail      = _LStorage.decrypt__get( 'iterable/encrypted/email' );
    this.userFirstName  = _LStorage.decrypt__get( 'iterable/encrypted/firstName' );
    this.userLastName   = _LStorage.decrypt__get( 'iterable/encrypted/lastName' );

    this.APIObj     = Object.assign(
        {},
        {
            email               : this.userEmail,
            wp_email_to         : 'forms@iterable.com',
            wp_email_subject    : 'Download Submission',
            wp_email_message    : null, //we gotta build this message body
            listUpload          : true,
        },
        _model.model__getUTMs(),
        attribution.helper__addWebHistory()
    );


    this.init();
};

DownloadUI.prototype.init = function(){

    //testing
    this.$confirmationWrap.on( 'click', ()=>{

        this.helper__confirmationAnimations();
    } );

    //init the deckable class
    this.deckable = new Deckable( this.$el , {} );

    //events
    this.$form
        .on( 'submit', _Forms.event__PreventDefault )
        .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault )
        .on( 'formvalid.zf.abide', this.event__validFrom.bind(this) );

    this.$wrongUser.on( 'click', this.event__goToForm.bind(this) );

    this.$returningUserCTA.on( 'click', this.event__returningUserCB.bind( this ) );

    this.$downloadImg.on( 'mouseenter', this.event__tada.bind(this) );

    //call up the CONF helper function
    _Forms.event__deckBackDoor( this.deckable, 'confirmation' );


    //ROUTER
    if( this.APIObj.email ){

        setTimeout( ()=>{

            this.view__knownUser();

        } , 250 );


    }else{

        this.deckable.goToDeck( 'form' );
    }

};

DownloadUI.prototype.event__validFrom = function( event, target ){

    var that = this;

    //disable normal submit event
    event.preventDefault();

    this.deckable.hideAllDecks();

    //serialize this data into name/value
    var formData = this.$form.serializeArray();
    //insert this data into a true key/value pairing by removing a layer of indexing
    $(formData).each(function() {
        that.APIObj[this.name] = this.value;
    } );

    //set encrypted LocalStorage
    //email
    _LStorage.encrypted__set( 'iterable/encrypted/email', this.APIObj.email );
    //firstName
    _LStorage.encrypted__set( 'iterable/encrypted/firstName', this.APIObj.firstName );
    //lastName
    _LStorage.encrypted__set( 'iterable/encrypted/lastName', this.APIObj.lastName );

    //set the email value from the localstorage obj
    this.APIObj.email = this.userEmail = _LStorage.decrypt__get( 'iterable/encrypted/email' );

    //replace the text with the user's name
    $(that.$userName).text( this.APIObj.firstName );

    //jump to success
    this.deckable.goToDeck( 'confirmation' );

    //there are no annimations for the contact form (as of now, so let's hide it)
    if( ! this.isContact ){
        this.helper__confirmationAnimations();
    }

    //trigger Google Tag Manager event for Adwords conversion here!
    window.dataLayer.push({'event' : 'ajaxFormSubmitted'});
};


//if email is available,
DownloadUI.prototype.view__knownUser = function(){
    var that = this,
        data = null;

    //if there is no values from getting the decrypted local storage - then show the form
    if( !this.userEmail || !this.userFirstName || !this.userLastName ){
        that.deckable.goToDeck( 'form' );
    }

    //replace the text with the user's name
    $(that.$userName).text( this.userFirstName );

    //replace the text with the user's email
    $(that.$userEmailEl).text( that.userEmail );

    //jump to ungated slide
    that.deckable.goToDeck( 'known-user' );

    //start building the object to send through the API calls
    //create an object for the sending data to the API and
    this.helper__getHiddenMetadata();

    //get the email address/first name/ last name/company from API
    that.APIObj.email       = this.userEmail;
    that.APIObj.firstName   = this.userFirstName;
    that.APIObj.lastName    = this.userLastName;

};


DownloadUI.prototype.event__returningUserCB = function( event ){

    event.preventDefault();

    //Show the loading biz
    this.deckable.hideAllDecks();

    //jump to success
    this.deckable.goToDeck( 'confirmation' );
    this.helper__confirmationAnimations();

    //trigger Google Tag Manager event for Adwords conversion here!
    window.dataLayer.push({'event' : 'ajaxFormSubmitted'});
};


DownloadUI.prototype.event__goToForm = function( event ){


    event.preventDefault();

    this.deckable.goToDeck( 'form' );

};

DownloadUI.prototype.helper__confirmationAnimations = function(){

    _Gsap.confirmationAnimation( this.$confirmationWrap );

};

DownloadUI.prototype.helper__updateFormInputs = function( data ){


    $.each( this.$visibleInputs, function (i ,v) {

        var input =  $( `[name=${v}]` );

        if( input.is( 'select' ) ){

            input.val( data[v] ).attr( 'selected', 'selected' ) ;

        }else{
            input.val( ( ! _model.empty( data[v] ) ) ? `${data[v]}` : '' );
        }


    } );

};

DownloadUI.prototype.event__tada = function( event ){

    const target = $(event.target);

    $(target).itblAnimate( 'animated', 'tada' );

};

DownloadUI.prototype.helper__getHiddenMetadata = function(){

    var that = this;

    //select all the hidden fields
    var hiddenInputs = $( that.$form ).find( "input[type='hidden']" );
    //add hidden inputs to the values obj
    $( hiddenInputs ).each(function() {
        that.APIObj[this.name] = this.value;
    });

};



